import React from 'react';
import {compose} from 'redux';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {connect} from 'react-redux';
import {isEmpty as _isEmpty} from 'lodash';
import {Button, Header, Icon} from 'semantic-ui-react';

import {graphql} from 'react-apollo';
import Authorization from '@appComponents/Authorization';
import Link from '@appComponents/Link';
import {
    USER_GRANT_APP_CONFIRMATION,
    USER_GRANT_APP_ERROR,
    USER_GRANT_APP_HEADER,
    USER_GRANT_APP_PROGRESS,
    USER_GRANT_APP_SUCCESS,
} from '@constants/messages';
import * as RESOURCES from '@constants/resources';
import * as CONST from '@constants/variables';
import {refetchQueryByName} from '@utils/apollo';
import {showMessageBox} from '@utils/messageBox';
import {UserGranted} from '@graphql/user/query';
import {GrantAppAccess, RevokeAppAccess} from '@graphql/user/mutation';
import mapModulesToProps from '@utils/mapModulesToProps';
import {
    MESSAGE_BOX_USERS_AFTER_GRANT_ERROR_NAME, MESSAGE_BOX_USERS_AFTER_GRANT_NAME,
} from '@modules/user/utils/variables';

const authorizationObject = {
    [RESOURCES.USER]: CONST.SECURITY_PRIVILEGES_READ_UPDATE,
};

export class UserEditButtons extends React.Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        DataUserAppAccess: PropTypes.shape({
            user: PropTypes.object,
            loading: PropTypes.bool.isRequired,
            refetch: PropTypes.func.isRequired,
        }),
        GrantAppAccess: PropTypes.func.isRequired,
        RevokeAppAccess: PropTypes.func.isRequired,
        Modal: PropTypes.shape({
            setModal: PropTypes.func.isRequired,
            setModalConfirmation: PropTypes.func.isRequired,
        }).isRequired,
    };

    state = {
        email: null,
        showAppGrantToggle: false,
        hasAppAccess: false,
    };

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props
            && false === this.props.DataUserAppAccess?.loading
            && !_isEmpty(this.props.DataUserAppAccess.user?.iam_user)) {
            this.setStateData();
        }
    }

    componentDidMount() {
        if (false === this.props.DataUserAppAccess?.loading
            && !_isEmpty(this.props.DataUserAppAccess.user?.iam_user)) {
            this.setStateData();
        }
    }

    setStateData = () => {
        this.setState({
            'showAppGrantToggle': !this.props.DataUserAppAccess.user.iam_user.blocked,
            'email': this.props.DataUserAppAccess.user.email,
            'hasAppAccess': this.props.DataUserAppAccess.user.iam_user.accessGranted,
        });
    };

    toggleActionRequest = () => {
        const grant = !this.state.hasAppAccess;

        const {
            DataUserAppAccess,
            GrantAppAccess,
            RevokeAppAccess,
            Modal: {setModal},
        } = this.props;

        this.props.Modal.setModalConfirmation({
            text: USER_GRANT_APP_PROGRESS,
        });

        return (grant ? GrantAppAccess : RevokeAppAccess)({
            variables: {
                email: this.state.email,
            },
        }).then(() => {
            showMessageBox(MESSAGE_BOX_USERS_AFTER_GRANT_NAME, USER_GRANT_APP_SUCCESS, null, 'success');
            setModal({isVisible: false});
            DataUserAppAccess.refetch();
            refetchQueryByName('GetUserWithAccessInformation', true);
        }).catch((error) => {
            setModal({isVisible: false});
            showMessageBox(MESSAGE_BOX_USERS_AFTER_GRANT_ERROR_NAME, USER_GRANT_APP_ERROR, `${error}`, 'error');
        });
    };

    toggleAccessClick = (e) => {
        e.preventDefault();

        this.props.Modal.setModalConfirmation({
            header: <Header content={USER_GRANT_APP_HEADER(!this.state.hasAppAccess)}/>,
            onYes: this.toggleActionRequest,
            text: USER_GRANT_APP_CONFIRMATION(!this.state.hasAppAccess),
        });
    };

    render() {
        return (
            <div className='content__buttons'>
                {!this.state.showAppGrantToggle ? null :
                    <Authorization authorization={authorizationObject}>
                        <Button onClick={this.toggleAccessClick}>
                            {this.state.hasAppAccess ? 'Revoke access to AV-CMP' : 'Grant access to AV-CMP'}
                        </Button>
                    </Authorization>}
                <Link name={'users.index'}>
                    <Button className='button-back'>
                        <Icon className='arrow circle left'/>{'Back to list'}
                    </Button>
                </Link>
            </div>
        );
    }
}

const UserEditButtonsWithQuery = compose(
    graphql(UserGranted, {
        skip: (props) => props.match.path.includes('from-existing-iam-account'),
        options: ({id}) => ({
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'network-only',
            variables: {id: id},
        }),
        name: 'DataUserAppAccess',
    }),
    graphql(GrantAppAccess, {name: 'GrantAppAccess'}),
    graphql(RevokeAppAccess, {name: 'RevokeAppAccess'})
)(UserEditButtons);

const mapDispatchToProps = mapModulesToProps(['Modal']);

export default withRouter(connect(null, mapDispatchToProps)(UserEditButtonsWithQuery));
